import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "./baseQuery";
import { API_SERVER } from "../utils/urlBack_End";

export const pagosApi = createApi({
  reducerPath: "pagosApi",
  baseQuery: baseQuery(`${API_SERVER}/pagos`),
  tagTypes: ["facturaDetalle"],
  endpoints: (builder) => ({
    // Para facturas de planes (usuarios no cliente)
    obtenerDetalleFacturaPlanes: builder.query({
      query: (folio) => `/facturaPlanes/${folio}`,
      providesTags: (result, error, folio) => [
        { type: "facturaDetalle", id: `PLAN-${folio}` },
      ],
    }),

    // Abonos de una factura de plan (usado por el diálogo de pago)
    obtenerAbonosFacturaPlanes: builder.query({
      query: (folio) => `/abonosFacturasPlanes/${folio}`,
      providesTags: (result, error, folio) => [
        { type: "facturaDetalle", id: `PLAN-${folio}` },
      ],
    }),

    // Para facturas de tareas (usuarios no cliente)
    obtenerDetalleFacturaTareas: builder.query({
      query: (id) => `/facturaTareas/${id}`,
      providesTags: (result, error, id) => [
        { type: "facturaDetalle", id: `TAREA-${id}` },
      ],
    }),

    // Abonos de una factura de tareas (usado por el diálogo de pago)
    obtenerAbonosFacturaTareas: builder.query({
      query: (id) => `/abonosFacturasTareas/${id}`,
      providesTags: (result, error, id) => [
        { type: "facturaDetalle", id: `TAREA-${id}` },
      ],
    }),

    // Para facturas afectas (usuarios no cliente)
    obtenerDetalleFacturaAfecta: builder.query({
      query: (folio) => `/facturaAfecta/${folio}`,
      providesTags: (result, error, folio) => [
        { type: "facturaDetalle", id: `AFECTA-${folio}` },
      ],
    }),

    // Abonos de una factura afecta (usado por el diálogo de pago)
    obtenerAbonosFacturaAfecta: builder.query({
      query: (folio) => `/abonosFacturasAfecta/${folio}`,
      providesTags: (result, error, folio) => [
        { type: "facturaDetalle", id: `AFECTA-${folio}` },
      ],
    }),

    crearPagoPlan: builder.mutation({
      query: (body) => ({
        url: `/facturaPlanes`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, { folio }) =>
        error ? [] : [{ type: "facturaDetalle", id: `PLAN-${folio}` }],
    }),

    crearPagoTarea: builder.mutation({
      query: (body) => ({
        url: `/facturaTareas`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, { idFactura }) =>
        error ? [] : [{ type: "facturaDetalle", id: `TAREA-${idFactura}` }],
    }),

    crearPagoAfecta: builder.mutation({
      query: (body) => ({
        url: `/facturaAfecta`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, { folio }) =>
        error ? [] : [{ type: "facturaDetalle", id: `AFECTA-${folio}` }],
    }),

    eliminarPagoPlan: builder.mutation({
      query: ({ id, motivo, enviarCorreo, rolUsuario }) => ({
        url: `/facturaPlanes/${id}`,
        method: "DELETE",
        body: { motivo, enviarCorreo, rolUsuario },
      }),
      invalidatesTags: ["facturaDetalle"],
    }),

    eliminarPagoTarea: builder.mutation({
      query: ({ id, motivo, enviarCorreo, rolUsuario }) => ({
        url: `/facturaTareas/${id}`,
        method: "DELETE",
        body: { motivo, enviarCorreo, rolUsuario },
      }),
      invalidatesTags: ["facturaDetalle"],
    }),

    editarPagoPlan: builder.mutation({
      query: ({ id, motivo, rolUsuario, ...cambios }) => ({
        url: `/facturaPlanes/${id}/editar`,
        method: "PUT",
        body: { motivo, rolUsuario, ...cambios },
      }),
      invalidatesTags: ["facturaDetalle"],
    }),

    editarPagoTarea: builder.mutation({
      query: ({ id, motivo, rolUsuario, ...cambios }) => ({
        url: `/facturaTareas/${id}/editar`,
        method: "PUT",
        body: { motivo, rolUsuario, ...cambios },
      }),
      invalidatesTags: ["facturaDetalle"],
    }),

    cuadrarFactura: builder.mutation({
      query: ({ tipo, idFactura, folio, rolUsuario }) => ({
        url: `/cuadrarFactura`,
        method: "POST",
        body: { tipo, idFactura, folio, rolUsuario },
      }),
      invalidatesTags: ["facturaDetalle"],
    }),
  }),
});

export const {
  useObtenerDetalleFacturaPlanesQuery,
  useLazyObtenerDetalleFacturaPlanesQuery,
  useObtenerAbonosFacturaPlanesQuery,
  useObtenerDetalleFacturaTareasQuery,
  useLazyObtenerDetalleFacturaTareasQuery,
  useObtenerDetalleFacturaAfectaQuery,
  useLazyObtenerDetalleFacturaAfectaQuery,
  useEliminarPagoPlanMutation,
  useEliminarPagoTareaMutation,
  useEditarPagoPlanMutation,
  useEditarPagoTareaMutation,
  useCrearPagoPlanMutation,
  useCuadrarFacturaMutation,
  useObtenerAbonosFacturaTareasQuery,
  useCrearPagoTareaMutation,
  useObtenerAbonosFacturaAfectaQuery,
  useCrearPagoAfectaMutation,
} = pagosApi;
